export default {
  header: 'Wie viele Treue-Stempel hast du grad auf deiner Stempelkarte?',
  buttons: {
    continue: 'Weiter',
  },
  error_codes: {
    default: 'Da ist was schief gelaufen. Bitte versuche es erneut oder überprüfe die Internetverbindung.',
  },
};
